import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'vi',
    fullName: 'Vietnamese',
    nativeName: 'Tiếng Việt',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Điều gì đó tuyệt vời đang đến",
    landing_subtitle: "ArgVoid là một studio phát triển ứng dụng và trò chơi. Hãy theo dõi, những điều mới sẽ sớm ra mắt!",
    select_language: "Chọn ngôn ngữ",
    search_placeholder: "Tìm kiếm ngôn ngữ...",
    terms_title: "Điều khoản dịch vụ",
    policy_title: "Chính sách bảo mật",
    cookies_title: "Chính sách cookie",
    terms_content: `
        <strong>1. Chấp nhận các điều khoản</strong><br>
        Bằng cách truy cập ArgVoid, các Điều khoản dịch vụ này được chấp nhận. Nếu các điều khoản này không được đồng ý thì không nên sử dụng dịch vụ.<br><br>

        <strong>2. Sử dụng nền tảng</strong><br>
        ArgVoid và các ứng dụng của nó được cung cấp "nguyên trạng" cho mục đích thông tin và sáng tạo. Dịch vụ chỉ được sử dụng cho mục đích hợp pháp.<br><br>

        <strong>3. Hành vi bị cấm</strong><br>
        Nghiêm cấm khai thác lỗ hổng trang web, gửi thư rác hoặc cố gắng truy cập trái phép vào cơ sở hạ tầng.<br><br>

        <strong>4. Tuyên bố miễn trừ trách nhiệm</strong><br>
        Nền tảng và dịch vụ có thể được sửa đổi bất cứ lúc nào mà không cần thông báo trước. Không có bảo đảm nào được cung cấp về thời gian hoạt động hoặc tính sẵn có của dịch vụ.
    `,
    policy_content: `
        <strong>1. Thu thập thông tin</strong><br>
        Nền tảng này không yêu cầu xác thực người dùng hoặc tạo tài khoản tại thời điểm này. Không có thông tin nhận dạng cá nhân nào (chẳng hạn như tên hoặc địa chỉ email) được tích cực thu thập từ khách truy cập.<br><br>

        <strong>2. Dữ liệu sử dụng</strong><br>
        Các phân tích cơ bản, ẩn danh có thể được thu thập để hiểu lưu lượng truy cập trang web và cải thiện ứng dụng. Dữ liệu này không được liên kết với danh tính người dùng cá nhân.<br><br>

        <strong>3. Dịch vụ của bên thứ ba</strong><br>
        Các nhà cung cấp bên thứ ba có thể được sử dụng cho các dịch vụ lưu trữ và phân tích. Thực tiễn bảo mật của các nhà cung cấp tương ứng này chi phối dữ liệu ẩn danh được xử lý trên cơ sở hạ tầng của họ.<br><br>

        <strong>4. Bảo mật dữ liệu</strong><br>
        Các biện pháp bảo mật hợp lý được thực hiện để bảo vệ nền tảng. Tuy nhiên, không có phương thức truyền qua Internet nào là an toàn tuyệt đối.<br><br>
    `,
    cookies_content: `
        <strong>1. Cookie và bộ nhớ cục bộ là gì?</strong><br>
        Cookie và bộ nhớ cục bộ của trình duyệt là các tệp dữ liệu nhỏ được lưu trữ trên thiết bị để ghi nhớ các tùy chọn cấu hình qua các lần truy cập.<br><br>

        <strong>2. Mục đích sử dụng</strong><br>
        Trình duyệt LocalStorage được sử dụng nghiêm ngặt để lưu cài đặt cấu hình, chẳng hạn như:<br>
        - Tùy chọn ngôn ngữ<br>
        - Cấu hình giao diện người dùng (ví dụ: cài đặt bố cục hoặc chủ đề) <br>
        - Bộ đệm ứng dụng tạm thời<br><br>

        <strong>3. Không theo dõi</strong><br>
        Cookie và bộ nhớ cục bộ không được sử dụng cho mục đích quảng cáo hoặc theo dõi của bên thứ ba. Tất cả dữ liệu được lưu trữ chỉ dành cho chức năng cốt lõi của nền tảng.<br><br>

        <strong>4. Kiểm soát</strong><br>
        Dữ liệu trình duyệt có thể bị xóa bất kỳ lúc nào thông qua cài đặt trình duyệt, thao tác này sẽ đặt lại mọi cấu hình cục bộ.
    `,
    cookie_consent_text: "Chúng tôi sử dụng các cookie cơ bản để đảm bảo trang web hoạt động chính xác, chẳng hạn như duy trì phiên của bạn hoạt động, lưu tùy chọn ngôn ngữ của bạn và các cấu hình tùy chỉnh khác.",
    read_policy: "Đọc chính sách cookie",
    support_title: "Liên hệ hỗ trợ",
    support_subject_label: "Chủ thể",
    support_message_label: "Tin nhắn",
    support_submit_button: "Gửi tin nhắn",
    support_hint: "Lưu ý: Thao tác này sẽ mở ứng dụng email mặc định của bạn để gửi tin nhắn.",
    support_success_msg: "Đang mở ứng dụng email của bạn...",
    support_error_msg: "Không gửi được tin nhắn. Vui lòng thử lại sau.",
    explorer_title: "Nhà thám hiểm",
    history_title: "Lịch sử",
    animation_title: "Hoạt hình",
    config_title: "Cấu hình",
    tool_mouse: "Chọn (Ctrl+M)",
    tool_brush: "Bút vẽ (Ctrl+B)",
    tool_brush_mode: "Chuyển đổi chế độ (Rắn/Rõ ràng)",
    tool_eraser: "Tẩy (Ctrl+E)",
    tool_brush_size: "Điều chỉnh kích thước cọ",
    tool_bucket: "Điền (Ctrl+F)",
    tool_eyedropper: "Thuốc nhỏ mắt",
    tool_grid: "Lưới (Ctrl+Shift+B)",
    tool_rotate: "Xoay (Ctrl+Shift+R)",
    tool_flip_h: "Lật H (Ctrl+Shift+H)",
    tool_flip_v: "Lật V (Ctrl+Shift+V)",
    tool_transpose: "Chuyển cung (Ctrl+Shift+T)",
    label_width: "Chiều rộng",
    label_height: "Chiều cao",
    label_frames: "Số lượng khung hình",
    label_animation: "Phong cách hoạt hình",
    label_background_color: "Màu nền",
    label_interval: "Khoảng thời gian",
    tool_anim_config: "Cấu hình hoạt ảnh",
    label_new_width: "Chiều rộng mới",
    label_new_height: "Chiều cao mới",
    label_apply: "Áp dụng",
    label_colors: "Màu sắc",
    label_size: "Kích cỡ",
    label_tolerance: "Sức chịu đựng",
    val_horizontal: "Nằm ngang",
    val_vertical: "Thẳng đứng",
    val_sequence: "Sự liên tiếp",
    val_bounce: "Tung lên",
    val_random: "Ngẫu nhiên",
    val_solid: "Chất rắn",
    val_clear: "Thông thoáng",
    action_add_sheet: "Trang tính mới",
    action_import: "Nhập khẩu",
    action_export: "Xuất khẩu",
    action_sort_projects: "Loại",
    sort_date_old: "Cũ nhất đầu tiên",
    sort_date_new: "Mới nhất đầu tiên",
    sort_name_az: "Tên (A-Z)",
    sort_name_za: "Tên (Z-A)",
    action_new_sprite: "Thần mới",
    action_new_project: "Dự án mới",
    modal_save_all_title: "Lưu tất cả thay đổi",
    modal_save_all_desc: "Chọn nội dung cần lưu:",
    modal_save_selected: "Lưu đã chọn",
    action_saved: "Đã lưu",
    modal_create_sprite_title: "Tạo Hình Mới",
    modal_create_project_title: "Tạo dự án mới",
    modal_add_sheet_title: "Thêm trang tính mới",
    modal_rename_sheet_title: "Đổi tên trang tính",
    modal_rename_sprite_title: "Đổi tên Sprite",
    modal_delete_sprite_title: "Xóa Sprite",
    modal_delete_project_title: "Xóa dự án",
    modal_delete_sheet_title: "Xóa trang tính",
    placeholder_sprite_name: "Tên",
    placeholder_project_name: "Tên",
    placeholder_sheet_name: "Tên",
    placeholder_new_name: "Tên mới",
    action_create: "Tạo nên",
    action_add: "Thêm vào",
    action_rename: "Đổi tên",
    action_duplicate: "Nhân bản",
    action_delete: "Xóa bỏ",
    action_cancel: "Hủy bỏ",
    confirm_delete_sprite: "Bạn có chắc chắn muốn xóa sprite này?",
    confirm_delete_project: "Bạn có chắc chắn muốn xóa dự án này? Tất cả các sprite sẽ bị loại bỏ.",
    confirm_delete_sheet: "Bạn có chắc chắn muốn xóa trang tính này không?",
    err_select_sprite: "Vui lòng chọn một sprite đầu tiên.",
    err_select_project: "Vui lòng chọn một dự án đầu tiên.",
    err_name_empty: "Tên không được để trống.",
    err_sprite_exists: "Một sprite có tên đó đã tồn tại.",
    err_project_exists: "Một dự án có tên đó đã tồn tại.",
    err_no_content: "Không có nội dung để lưu.",
    err_no_changes: "Không có thay đổi nào để lưu.",
    err_delete_last_sheet: "Không thể xóa tờ cuối cùng.",
    err_extract_frames: "Không thể trích xuất bất kỳ khung hình nào.",
    err_indexeddb: "Không thể lưu cục bộ. Trình duyệt của bạn có thể không hỗ trợ IndexedDB.",
    msg_upload_success: "Tải lên thành công: {0}",
    msg_upload_failed: "Tải lên không thành công: {0}",
    msg_save_success: "Lưu thành công.",
    msg_saving: "Đang lưu...",
    msg_multi_save_result: "Đã lưu {0} nội dung. {1} thất bại.",
    menu_title: "Thực đơn",
    menu_save: "Cứu",
    menu_save_all: "Lưu tất cả",
    menu_support: "Liên hệ hỗ trợ",
    label_local_storage: "Bộ nhớ cục bộ",
    label_sign_in: "Đăng nhập",
    modal_export_title: "Xuất Sprite",
    label_filename: "Tên tệp",
    label_format: "Định dạng",
    action_export_confirm: "Xuất khẩu",
};

export default translations;
